module.exports = __webpack_public_path__ + "img/IT0001232771625.f22102b1.png";